import { money } from "@/lib/pricing";
import { Input } from "@/components/ui/input";
import { Heart } from "lucide-react";

const PCTS = [5, 10, 15];

export const tipAmount = (tip, subtotal) => {
  if (tip.type === "percent") return Math.round(subtotal * tip.pct) / 100;
  if (tip.type === "custom") return Math.max(0, Math.round((Number(tip.custom) || 0) * 100) / 100);
  return 0;
};

export const TipSelector = ({ tip, setTip, subtotal }) => {
  const chip = (on) => `rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${on ? "border-sugar-pink bg-sugar-pink text-white" : "border-sugar-border bg-white text-sugar-ink2 hover:border-sugar-pink/50"}`;
  return (
    <div data-testid="tip-section" className="mt-6">
      <label className="mb-1.5 block text-sm font-bold text-sugar-ink"><Heart size={15} className="mr-1 inline text-sugar-pink" /> Add a tip (optional)</label>
      <div className="flex flex-wrap gap-2">
        <button type="button" data-testid="tip-none" onClick={() => setTip({ type: "none", pct: 0, custom: "" })} className={chip(tip.type === "none")}>No tip</button>
        {PCTS.map((p) => (
          <button key={p} type="button" data-testid={`tip-${p}`} onClick={() => setTip({ type: "percent", pct: p, custom: "" })} className={chip(tip.type === "percent" && tip.pct === p)}>
            {p}% <span className="opacity-75">({money(Math.round(subtotal * p) / 100)})</span>
          </button>
        ))}
        <button type="button" data-testid="tip-custom" onClick={() => setTip({ type: "custom", pct: 0, custom: tip.custom })} className={chip(tip.type === "custom")}>Custom amount</button>
      </div>
      {tip.type === "custom" && (
        <Input data-testid="tip-custom-input" type="number" min="0" step="0.01" placeholder="Tip amount ($)" value={tip.custom}
          onChange={(e) => setTip({ type: "custom", pct: 0, custom: e.target.value })} className="mt-2 w-40 rounded-xl border-sugar-border" />
      )}
      <p className="mt-2 text-xs text-sugar-ink2">Tips are never required. Percent tips are based on your cake & add-ons price, before tax and delivery.</p>
    </div>
  );
};
